import { css } from '@emotion/react';
import { observer } from 'mobx-react-lite';
import { ReactElement } from 'react';

import { useSDK } from '../../../../app';
import { styled } from '../../../../styled';
import { AvatarIcon } from '../../../icons/avatar';

type Interface = { className: string; accountId?: number };

const styles = css`
	align-items: center;
	background-color: #e2e2e2;
	border-radius: 50%;
	color: #fff;
	display: flex;
	height: 36px;
	justify-content: center;
	line-height: 36px;
	width: 36px;

	& > img {
		border-radius: 50%;
		height: 36px;
		width: 36px;
	}
`;

const Component = observer(({ className, accountId }: Interface): ReactElement => {
	const { accountsStore } = useSDK();
	const avatarUrl = accountId && accountsStore.getAvatarUrl(accountId);
	return <div className={className}>{avatarUrl ? <img src={avatarUrl} /> : <AvatarIcon />}</div>;
});

const MessageAvatar = styled(Component)(styles);

export { MessageAvatar };
